import MuiStack from '@mui/material/Stack';
import type { ComponentProps, Ref } from 'react';
import { forwardRef } from 'react';

export const Stack = forwardRef(function CustomComponent(
  props: ComponentProps<typeof MuiStack>,
  ref: Ref<HTMLDivElement>,
) {
  return <MuiStack {...props} ref={ref} useFlexGap />;
});
